export default Object.freeze({
  apiKey: "AIzaSyCmd4CvzqnrMofA3J92YtqNDEFAcevcYaU",
  authDomain: "katank-workrecord.firebaseapp.com",
  projectId: "katank-workrecord",
  storageBucket: "katank-workrecord.appspot.com",
  messagingSenderId: "347382648017",
  appId: "1:347382648017:web:589ded0dcafe08fbd489f0",
  measurementId: "G-X6MTS25VZJ",
});
